import { PaymentGateway } from '../../../../../services/exports/Constants';

export default {
  title: 'Klik på knappen herunder for at gennemgå og bekræfte dine betalingsoplysninger.',
  payment_gateways: {
    [PaymentGateway.Stripe]: {
      description:
        'Vi samarbejder med Stripe om håndtering af betalinger. Stripe er den mest sikre betalingsplatform, som bruges af verdens største virksomheder.',
      form: {
        terms_acceptance: {
          label:
            'Ved at fortsætte accepterer du vores <FoodAmigosTerms>servicevilkår</FoodAmigosTerms> og <StripeTerms>Stripes aftale for tilknyttede konti.</StripeTerms>',
        },
      },
      labels: {
        stripe_requirements:
          'Stripe har markeret nogle kundeoplysninger som manglende eller ugyldige. Ret følgende fejl ved at klikke på knappen „Åbn Stripe-profil“:',
        errors: 'Fejl',
        awaiting_verification: 'Din Stripe-konto bliver verificeret',
        awaiting_verification_description:
          'Vi venter på, at Stripe færdiggør verificeringen af din virksomhed. Du kan imens gennemgå din profil.',
      },
    },
    [PaymentGateway.Adyen]: {
      description:
        'Vi samarbejder med Adyen om håndtering af betalinger. Adyen er en af de mest sikre betalingsplatforme, som bruges af verdens største virksomheder.',
    },
  },
  labels: {
    verified: 'Din {{paymentGateway}}-konto er verificeret',
    verified_description:
      'Verificeringen er gennemført for {{paymentGateway}}. Du kan stadig administrere din profil, hvis det er nødvendigt.',
  },
  buttons: {
    proceed: 'Bekræft mine betalingsoplysninger',
    copy_link: 'Kopiér link',
  },
  toasts: {
    something_went_wrong: 'Noget gik galt. Kontakt teknisk support',
  },
};
